import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
Vue.use(VueRouter)
Vue.use(VueMeta)
const routes = [
  /*      {
        path: '/',
        name: 'Inicio',
        redirect: '/Inicio'
      },  */
  {
    path: '/',
    name: 'Inicio',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Inicio.vue'),
    meta: { auth: false }
  },
      {
    path: '/cursos',
    name: 'Cursos',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Cursos.vue'),
    meta: { auth: false }
  },
      {
    path: '/noticias',
    name: 'Noticias',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Noticias.vue'),
    meta: { auth: false }
  },
    {
    path: '/nosotros',
    name: 'Nosotros',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Nosotros.vue'),
    meta: { auth: false }
  },
      {
    path: '/contactos',
    name: 'Contactos',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Contactos.vue'),
    meta: { auth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Administracion.vue'),
    meta: { auth: false }
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import(/* webpackChunkName: "Help" */ '../views/Help.vue'),
    meta: { auth: false }
  },
  {
    path: "*",
    name: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
    scrollBehavior() {
    return { x: 0, y: 0 };
  }
  
})
router.beforeEach((to, from, next) => {
  if (to.meta.auth === undefined) { return next(); }

  const authRoute = (to.meta.auth);
  if (authRoute) {
    if (!Vue.auth.isAuth()) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else next();
  } else {
    if (Vue.auth.isAuth()) {
      next({ path: '/' })
    } else next();
  }
  next();
});


export default router
